import {
    createApp,
    defineAsyncComponent
} from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import SmoothScroll from './smooth-scroll'
// import Parallax from './parallax.js'
import SiteDrawer from './plugins/site-drawer/index.js'

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
import CookiesBar from './components/cookies-bar/index.vue'
import BtnTop from './components/btn-top/index.vue'
import BgImage from './components/bg-image/index.vue'
import BgVideo from './components/bg-video/index.vue'
import FancyBox from "./components/fancy-box/index.vue";
import MenuCircle from "./menu-circle.vue";
import SplashScreen from "./splash-screen.vue";
const TextWings = defineAsyncComponent(() => import('./components/text-wings/index.vue'))
// const SplashScreen = defineAsyncComponent(() => import('./splash-screen.vue'))
const HomeIcons = defineAsyncComponent(() => import('./home-icons.vue'))
const CountOnView = defineAsyncComponent(() => import('./components/count-on-view/index.vue'))
const MapDots = defineAsyncComponent(() => import('./map-dots.vue'))
const SectionAbout = defineAsyncComponent(() => import('./section-about.vue'))
const SectionFleet = defineAsyncComponent(() => import('./section-fleet.vue'))
const Circles = defineAsyncComponent(() => import('./circles.vue'))
const MapWrapper = defineAsyncComponent(() => import('./map-wrapper.vue'))
const GoogleMap = defineAsyncComponent(() => import('./components/google-map/index.vue'))
const SectionCareers = defineAsyncComponent(() => import('./section-careers.vue'))
const SectionServices = defineAsyncComponent(() => import('./section-services.vue'))
const OnboardForm = defineAsyncComponent(() => import('./onboard-form.vue'))
const OnshoreForm = defineAsyncComponent(() => import('./onshore-form.vue'))
const ContactForm = defineAsyncComponent(() => import('./contact-form.vue'))

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES
import { gsap } from "gsap";
import MouseCoords from "./directives/mouse-coords/index.js";

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

import bootstrapModal from "bootstrap/js/dist/modal";

import { viewportSize, devices } from './imports/utils'

createApp({
    mixins: [SmoothScroll],
    components: {
        CookiesBar,
        TextWings,
        SplashScreen,
        HomeIcons,
        BtnTop,
        MenuCircle,
        CountOnView,
        MapDots,
        SectionAbout,
        SectionFleet,
        Circles,
        MapWrapper,
        GoogleMap,
        SectionCareers,
        SectionServices,
        OnboardForm,
        OnshoreForm,
        ContactForm
    },
    directives: {
        MouseCoords,
    },
    data() {
        return {
            scrollTop: window.scrollY,
            viewportSize: viewportSize(),
            isDevice: devices(),
            showBtnScroll: false,
            whiteBtnScroll: false,
            whiteBadgeFixed: false,
            menuOpen: false,
            mapFullscreen: false,
        }
    },
    methods: {
        onMenuOpen() {
            this.menuOpen = true
            this.disableScroll()
        },
        onMenuClose() {
            this.menuOpen = false
            this.enableScroll()
        },
        showModal(id) {
            const modalEl = document.getElementById(id);

            new bootstrapModal(modalEl).show();

            modalEl.addEventListener('shown.bs.modal', event => {
                this.disableScroll();
            });

            modalEl.addEventListener('hidden.bs.modal', event => {
                this.enableScroll();
            });
        },
        onResize() {
            this.viewportSize = viewportSize()
        },
        animateHomepage() {
            gsap.timeline()
                .to(".animation-header-mask", {
                    opacity: 1,
                    duration: 3,
                    ease: "ease.in",
                })
                .to(".page-badge.home-page", {
                    backgroundPositionX: "-4vh",
                    backgroundPositionY: this.viewportSize.width < 576 ? "50vw" : this.viewportSize.width < 768 ? "38vw" : "19rem",
                    opacity: 1,
                    duration: 3,
                    ease: "power3.out",
                    delay: -2.5,
                })
                .to(".animation-title", {
                    opacity: 1,
                    duration: 1,
                    delay: -2.5,
                })
                .to(".animation-subtitle", {
                    opacity: 1,
                    duration: 1,
                    delay: -2.25
                })
                .to(".animation-line", {
                    height: "100%",
                    duration: 1,
                    delay: -2
                })
                .to(".animation-text", {
                    opacity: 1,
                    x: 0,
                    duration: 1,
                    delay: -1.75
                })
                .to(".animation-button", {
                    opacity: 1,
                    duration: 1,
                    delay: -1.5
                })
                .to(".animation-scroll-btn", {
                    opacity: 1,
                    duration: 1,
                    delay: -1.5
                })
                // .to(".home-photos .photo", {
                //     opacity: 1,
                //     duration: 1,
                //     delay: -1.5,
                //     stagger: {
                //         each: 0.35,
                //     },
                // })
                .to(".animation-line-2", {
                    height: this.viewportSize.width > 575 ? "80vh" : "60vh",
                    duration: 1,
                    delay: -1.5
                });
        }
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')

        window.addEventListener("resize", this.onResize, {
            passive: true
        })
    },
    mounted() {
        if (this.isDevice) {
            document.getElementsByTagName("html")[0].classList.add("is-device")
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize)
    }
})
    .use(SiteDrawer)
    .component('BgImage', BgImage)
    .component('BgVideo', BgVideo)
    .component('FancyBox', FancyBox)
    // .component('bsModal', bsModal)
    .mount('#app')